/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ROUTES } from '@sportninja/common/constants/app'
import colors from '@sportninja/common/constants/appColors'
import EditProfileModal from '../Profile/EditProfileModal'
import NotificationSettingsModal from '../../components/NotificationSettingsModal'
import { useProfileContext } from './context/ProfileContext'
import { useProfilePages } from './hooks/useProfilePages'
import ProfileHeader from './components/ProfileHeader'
import ProfileNavBar from './components/ProfileNavBar'
import { MAX_CONTENT_WIDTH } from './utils/constants'

const ProfilePage: React.FC = () => {
  const {
    item,
    selfPlayerIds,
    players,
    loadedPlayers,
    showStats,
    suspensions,
    suspensionLoading,
    isSuspended,
    isNotificationSettingsOpen,
    isEditOpen,
    readItem,
    setShowStats,
    openNotificationSettings,
    closeNotificationSettings,
    openEditModal,
    closeEditModal,
  } = useProfileContext()

  const pages = useProfilePages({
    showStats,
    selfPlayerIds,
    players,
    suspensionLoading,
    suspensions,
    setShowStats,
  })

  return (
    <div
      css={css`
        min-height: 100vh;
        background-color: ${colors.SECONDARY_500};
        margin-bottom: 100px;
      `}
    >
      <ProfileHeader
        item={item}
        isSuspended={isSuspended}
        suspensions={suspensions}
        onEditClick={openEditModal}
        onSettingsClick={openNotificationSettings}
      />
      <ProfileNavBar baseRoute={ROUTES.PROFILE.ROOT} pages={pages} />

      <div
        css={css`
          max-width: ${MAX_CONTENT_WIDTH}px;
          margin: 0 auto;
        `}
      >
        {loadedPlayers && (
          <Switch>
            {pages.map((page, idx) => (
              <Route
                key={page.to}
                exact
                path={idx === 0 ? ROUTES.PROFILE.ROOT : page.to}
              >
                {page.component}
              </Route>
            ))}
          </Switch>
        )}
      </div>

      <EditProfileModal
        isOpen={isEditOpen}
        onClose={closeEditModal}
        onSuccess={() => {
          readItem(true).catch(() => undefined)
        }}
      />
      <NotificationSettingsModal
        isOpen={isNotificationSettingsOpen}
        onClose={closeNotificationSettings}
      />
    </div>
  )
}

export default ProfilePage
